export enum ActivityCardConflictType {
  MissingTimes = 'missingTimes',
  Intersection = 'intersection',
  TimeAndLocation = 'timeAndLocation',
  TimeConflict = 'timeConflict',
  LocationConflict = 'locationConflict',
  PauseTooShort = 'pauseTooShort',
  NoConflict = 'noConflict',
}
